export default __webpack_public_path__ + "static/media/hr.d894134b.svg";